// Shared KNOWLEDGE-surface primitives — the small building blocks the Memory / Files / Team / Settings
// surfaces reuse, mapped onto the prototype's own classes (brand/ritona-app-handoff app.css .chip / .kv).
// The sub-tab bar lives in the shell chrome (screen-chrome.tsx ScreenSubTabs) so every screen's tabs render
// identically. Tokens only (G-181); kept here so each surface component stays small (G-085).

import type { ReactNode } from 'react';

/** A quiet tag chip (prototype .chip) — a rounded-sm control shape, never a rounded-full pill. */
export function Chip({ children }: { readonly children: ReactNode }): React.JSX.Element {
  return <span className="chip">{children}</span>;
}

/** A key/value row (prototype .kv) — the quiet key on the left, the semibold value on the right. */
export function KeyValue({
  label,
  children,
}: {
  readonly label: string;
  readonly children: ReactNode;
}): React.JSX.Element {
  return (
    <div className="kv">
      <span className="kv-k">{label}</span>
      <span className="kv-v">{children}</span>
    </div>
  );
}
